import * as React from 'react';
import * as classnames from 'classnames';

import Icon from './Icon';

export interface TabOption {
	label: string;
	value: string;
	labelIcon?: string;
}

interface Props {
	options: TabOption[];
	contentLabel: string;
	selectedOption: string;
	className?: string;
	title: string;
	onSelect(option: string): void;
}

export default class Tabs extends React.Component<Props, {}> {

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleSelectOption = this.handleSelectOption.bind(this);
	}

	public render() {
		return <div className='tabs-container'>
			<label className='tabs-title'>{this.props.title}</label>
			<form className='tabs'>
				{this.renderTabs()}
			</form>
		</div>;
	}

	private renderTabs() {
		const {options} = this.props;
		return options.map((option, index) => this.renderTab(option));
	}

	private renderTab(option: TabOption) {
		const className = classnames(
			'tab',
			this.getTabActiveClass(option.value),
			this.props.className || '',
		);
		return <div
			key={option.value}
			className={className}
		>
			<label>
				<input
					type='radio'
					name={`tab-option-${this.props.contentLabel}`}
					value={option.value}
					onChange={this.handleSelectOption}
					checked={option.value === this.props.selectedOption}
				/>
				<h3 className='tab-text'>
					{option.label}
				</h3>
				{!!option.labelIcon && <Icon className='tab-label-icon' name={option.labelIcon} />}
			</label>
		</div>;
	}

	private handleSelectOption(event: React.ChangeEvent<HTMLInputElement>) {
		const selectedOption = (event.currentTarget as HTMLInputElement).value;
		this.props.onSelect(selectedOption);
	}

	private getTabActiveClass(value: string) {
		return value === this.props.selectedOption ? 'active' : '';
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/Tabs.tsx